import script from "./ServiceCenter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceCenter.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceCenter.vue?vue&type=style&index=0&id=630cf326&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630cf326"]])

export default __exports__